import { Modal, Spinner } from 'react-bootstrap'
import './CancelModal.scss'
import { useTranslation } from 'react-i18next';
import { Machine } from '../../../utils/models/Machine';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../utils/redux/userSlice';
import { useState } from 'react';

const CancelModal = (props: { showModal: boolean, onHide: () => void, machine: Machine, onChangeStateMachine: (active: boolean) => void }) => {
    const { t } = useTranslation();
    const user = useSelector(selectUser)

    const [loading, setLoading] = useState(false)


    const onClickYes = () => {
        props.onChangeStateMachine(false)
        props.onHide()

    }

    const onClickCancel = () => {
        props.onHide()
    }


    return (
        <>
            <Modal show={props.showModal} keyboard={false} backdrop={'static'}>
                <Modal.Body className='modalBodyParent'>
                    <header className='modalHeader px-3 py-2'>
                        <span className='h4'>{t('CancelSubscription')} <span >{props.machine.name}</span></span>

                    </header>
                    <div className='modalBody px-3 py-2 d-flex flex-column text-center'>
                        <i className="bi bi-exclamation-circle" style={{ color: 'red', fontSize: '6rem' }}></i>
                        <span className='h5'>{t('AreYouSureToCancelSubscription')}</span>
                    </div>
                    <footer className="d-flex flex-row px-3 py-2 gap-2">
                        {!loading ? <><button className="btn-Custom btn-IDGreen flex-fill" onClick={onClickYes}>
                            {t('Yes')}
                        </button>
                            <button className="btn-Custom btn-Grey flex-fill" onClick={onClickCancel}>
                                {t("No")}
                            </button></> : <div className='text-center'><Spinner animation="border" variant="warning" /></div>}
                    </footer>
                </Modal.Body>
            </Modal >
        </>
    )
}

export default CancelModal